import hash from '@emotion/hash';
var _hash_default;
// Something about Emotion’s build process causes the CJS option to load
// sometimes, so we handle both cases.
const murmur2 = (_hash_default = hash.default) !== null && _hash_default !== void 0 ? _hash_default : hash;
const PREFIX = 'engine-';
export function getClassName(content, prefix = PREFIX) {
    return `${prefix}${murmur2(content)}`;
}
export function getSelector(content, prefix) {
    return `.${getClassName(content, prefix)}`;
}

//# sourceMappingURL=selector.js.map